/*
 * @Author: wsx
 * @Date: 2022-01-15 15:00:57
 * @LastEditTime: 2022-01-21 14:52:21
 * @LastEditors: your name
 * @Description: util
 */

let videoDom = null;
let resizeBody = {}; // 保存上此设置控件位置的信息

/*
 * 转换为JSON对象
 */
export const toJSON = data => {
  if (data && typeof data !== "object") {
    data = JSON.parse(data);
  }
  return data;
};

/**
 * 判断是否为json字符串
 */
export const isJSON = str => {
  if (typeof str === "string") {
    try {
      // var obj = JSON.parse(str);
      if (str.indexOf("{") > -1) {
        return true;
      } else {
      }
    } catch (e) {
      // console.log(e);
      return false;
    }
  }
  return false;
};

/**
 * @Description: 获取视频播放区域尺寸
 * @param {string} id
 */
export const getSize = el => {
  let oDiv = el;
  // 获取视频播放区域尺寸
  if (typeof el === "string") {
    oDiv = document.getElementById(el);
  }
  if (!oDiv) {
    console.error(`${el} not found`);
    return false;
  }
  const videoDom = oDiv.getBoundingClientRect();
  const { top, Left } = getElOptions(oDiv);
  videoDom.domLeft = Left;
  videoDom.domTop = top;
  return videoDom;
};

/**
 * 获取初始化/位置重置请求体
 * @param {string} id 对讲控件绑定的标签id
 * @param {object} reqBody 请求
 */
export const getTalkReqBody = (id, reqBody = {}) => {
  videoDom = getSize(id);
  const theX =
    document.documentElement.scrollLeft ||
    window.pageXOffset ||
    document.body.scrollLeft; // 滚动条
  const theY =
    document.documentElement.scrollTop ||
    window.pageYOffset ||
    document.body.scrollTop; // 滚动条
  const innerH = window.innerHeight; // 浏览器窗口高度(不包括菜单栏工具栏)
  const outH = window.outerHeight; // 整个浏览器高度
  const toolH = outH - innerH; // 工具栏高度
  const deviationX = 8; // 左侧偏差值
  let deviationY = 5; // 右侧偏差值
  if (toolH < 70) {
    deviationY = 5;
  } else {
    deviationY = 8;
  }
  reqBody.height = Math.ceil(videoDom.height);
  reqBody.width = Math.ceil(videoDom.width);
  reqBody.mgx = Math.ceil(
    videoDom.left - document.documentElement.clientLeft + theX + deviationX
  );
  if (reqBody.mgx < 0) {
    reqBody.mgx = resizeBody.mgx;
  }
  reqBody.mgy = Math.ceil(
    videoDom.top -
      document.documentElement.clientTop +
      toolH +
      theY +
      deviationY
  );
  if (reqBody.mgy < 0) {
    reqBody.mgy = resizeBody.mgy;
  }
  resizeBody = reqBody;
  return reqBody;
};

/**
 * 获取dom节点的 坐标(top,left)
 * @param {*} element dom节点
 * @returns
 */
export const getElOptions = element => {
  let top = element.offsetTop;
  let Left = element.offsetLeft;
  let current = element.offsetParent;
  while (current != null) {
    top += current.offsetTop;
    Left += current.offsetLeft;
    current = current.offsetParent;
  }

  return { top, Left };
};
